<template>
  <div class="field" :class="{ 'required' : allowEdit && isFieldRequired, 'error' : hasScopeError}">
    <label :for="field.name">{{ field.name }}</label>

    <div class="ui input"
         :class="{ 'transparent' : transparent,  'disabled' : !isFieldEditable, 'corner labeled' : isFieldRequired }"
         v-if="field.type !== 'select' && field.type !== 'textarea'">
      <input :type="field.type" :value="fieldValue" :data-vv-scope="scope" :name="field.name" :readonly="!allowEdit"
             :data-vv-value-path="fieldValue" :disabled="!isFieldEditable"
             @input="updateFieldValue($event.target.value)" v-validate="{ required: isFieldRequired }">

      <div class="ui corner label" v-if="allowEdit && isFieldRequired">
        <i class="asterisk icon"/>
      </div>
    </div>

    <div class="ui input"
         :class="{ 'transparent' : transparent,  'disabled' : !isFieldEditable, 'corner labeled' : isFieldRequired }"
         v-if="field.type === 'textarea'">
      <textarea :class="{ 'disabled' : !isFieldEditable, 'non-resizable' : !allowEdit }"
                :value="fieldValue"
                :data-vv-scope="scope"
                :name="field.name" :readonly="!allowEdit" :data-vv-value-path="fieldValue" :disabled="!isFieldEditable"
                @input="updateFieldValue($event.target.value)" v-validate="{ required: isFieldRequired }" cols="30"
                rows="10"></textarea>
    </div>

    <semantic-form-dropdown :class="{ 'disabled' : !isFieldEditable }" :value="fieldValue" :data-vv-scope="scope"
                            :disabled="!allowEdit" :name="field.name" @dropdown-selected="updateFieldValue"
                            :options="getSelectOptions" :required="field.required" v-else-if="field.type === 'select'"
                            v-validate="{ required: isFieldRequired }" :multiple="multiple" :settings="settings" :placeholder="placeholder"/>

    <span v-if="hasScopeError" style="color: red;">{{ getScopeError }}</span>
    <slot v-if="!hasScopeError" name="subMessage"></slot>
  </div>
</template>

<script>
import find from 'lodash/find'

export default {
  name: 'Field',

  inject: ['$validator'],

  data() {
    return {
      fallbackValue: (find(this.value, {id: this.field.id})) ? find(this.value, {id: this.field.id}).value : null
    }
  },

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    settings: {
      type: Object,
      default: () => {
      }
    },

    field: {
      type: Object,
      default: null
    },
    allowEdit: {
      type: [Boolean, Number],
      default: true
    },
    transparent: {
      type: Boolean,
      default: false
    },
    scope: {
      required: true,
      type: String
    },
    value: {
      default: () => [],
      type: Array
    },
    isactive: {
      default: false,
      type: Boolean
    },
    isSubFieldValid: {
      required: false,
      default: true,
      type: Boolean
    },
    areAllSubsChosen: {
      required: false,
      default: true,
      type: Boolean
    },
    metas: {
      default: () => {
        return []
      },
      type: [Array, Object]
    },
    winterPlace: {
      required: false,
      default: () => {
        return {}
      },
      type: Object
    },
    placeholder: {
      required: false,
      type: String,
      default: '',
    }
  },

  watch: {
    fieldValue(newValue) {
      this.$emit('input', {
        id: this.field.id,
        value: newValue,
        editable: this.field.editable,
        required: this.field.required
      })
    },

    field(newField) {
      if (this.field && this.field.id) {
        const _find = find(this.metas, {field_id: this.field.id});
        if (_find) {
          this.fallbackValue = _find.value;
        }
      }
      this.field = newField
    },

    winterPlace(newField) {
      if (this.field && this.field.id) {
        if (newField.id === this.field.id) {
          this.fallbackValue = newField.value;
        }
      }
    }
  },

  mounted() {
    this.fallbackValue = null;
    this.fallbackValue = (find(this.value, {id: this.field.id})) ? find(this.value, {id: this.field.id}).value : null;
    if (find(this.metas, {field_id: this.field.id})) {
      this.fallbackValue = find(this.metas, {field_id: this.field.id}) ? find(this.metas, {field_id: this.field.id}).value : null
    }
  },

  computed: {
    fieldValue() {
      if (typeof this.field.meta === 'undefined' || typeof this.field.meta.value === 'undefined' || !this.field.meta) {
        return this.fallbackValue
      } else {
        return this.field.meta.value
      }
    },

    hasScopeError() {
      return this.errors.has(this.scope + '.' + this.field.name) || !this.isSubFieldValid || !this.areAllSubsChosen
    },

    getScopeError() {
      if (!this.isSubFieldValid) {
        return this.$t('modals.newbookingmodal.validation.subscription_field')
      } else if (!this.areAllSubsChosen) {
        return this.$t('modals.newbookingmodal.validation.not_all_subscriptions_chosen', {merchant: this.$store.getters.activeMerchant.name})
      }
      return this.errors.first(this.scope + '.' + this.field.name)
    },

    getSelectOptions() {
      const options = []
      if (typeof this.field.options === 'string') {
        $.map(JSON.parse(this.field.options), function (item, index) {
          options.push({name: item, id: index})
        })
      } else {
        $.map(this.field.options, function (item, index) {
          options.push({name: item, id: index})
        })
      }
      return options
    },

    isFieldEditable() {
      if (this.field.lock_after_active && this.isactive) {
        return false
      } else {
        return !!this.field.editable;
      }
    },

    isFieldRequired() {
      return (this.isFieldEditable && this.field.required) || this.field.name === 'Postnummer';
    }
  },

  methods: {
    updateFieldValue(newValue) {
      if (typeof this.field.meta === 'undefined' || typeof this.field.meta.value === 'undefined' || !this.field.meta) {
        this.fallbackValue = newValue
      } else {
        this.field.meta.value = newValue
      }
      this.$emit('fake-input', newValue);
    }
  }
}
</script>

<style scoped lang="scss">
  .field {
    textarea {
      &.non-resizable {
        resize: none;
        border: none;
        outline: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Field.vue